import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs/Observable';
import { filter, map } from 'rxjs/operators';
import { ConnectionProfilesActions } from './state/connection-profiles.actions';
import { ConnectionProfilesSelectors } from './state/connection-profiles.selectors';
import { BsModalConfirmComponent, createConfirmModalOptions } from '../core/modal/modal-confirm.component';
import { PreviewEditTemplateActions } from '../preview-edit-template/state/preview-edit-template.actions';

@Component({
    selector: 'connection-profiles',
    templateUrl: './connection-profiles.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ConnectionProfilesComponent implements OnInit {
    connectionProfiles$: Observable<Array<any>>;
    loading$: Observable<boolean>;

    connectionProfileId: any;
    selectedConnectionProfile: string;
    autoremindAccount: string;
    isUpdated = false;
    constructor(private previewBsModalRef: BsModalRef,
                private connectionProfilesSelectors: ConnectionProfilesSelectors,
                private modalService: BsModalService,
                private store: Store<any>) {
        this.connectionProfiles$ = this.connectionProfilesSelectors.selectConnectionProfiles();
        this.loading$ = this.connectionProfilesSelectors.selectLoading();
    }

    public onCancel(): void {
        if (this.isUpdated) {
            const modalRef = this.modalService
                .show(BsModalConfirmComponent, createConfirmModalOptions('Confirm',
                    'You will loose all unsaved changes. Are you sure you want to exit?',
                    'Yes', 'No'));

            modalRef.content.onClose
                .subscribe(dialogResult => {
                    if (dialogResult.isConfirmed) {
                        this.isUpdated = false;
                        this.previewBsModalRef.hide();
                    }
                });
        } else {
            this.previewBsModalRef.hide();
        }
    }

    public saveChanges(): void {
        if (this.isUpdated) {
            this.store.dispatch(ConnectionProfilesActions.updateConnectionProfiles(
                {autoremindAccount: this.autoremindAccount, selectedConnectionProfileId: this.connectionProfileId}));
        }
        this.previewBsModalRef.hide();
    }

    ngOnInit(): void {
        this.store.dispatch(ConnectionProfilesActions.getConnectionProfiles());
        const config: any = {...this.modalService.config.initialState};
        this.selectedConnectionProfile = config.selectedConnectionProfile;
        this.autoremindAccount = config.autoremindAccount;
    }

    onChange(): void {
        this.isUpdated = true;
    }

    setSelectedId(isSelected, connectionProfileId): void {
        if (isSelected) {
            this.connectionProfileId = connectionProfileId;
        }
    }

}
